import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      const main = document.getElementById("main");
      if (main) {
        main.focus({ preventScroll: true });
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}